import React from "react";

import { observer } from "mobx-react-lite";
import { PlayerCalculatedStats } from "../../../apis/types";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/TCText/TCText";
import { useMatchDetailsStore } from "../../../stores/StoreContext";

type props = {
  title: string;
  showPercentage?: boolean;
  player1: PlayerCalculatedStats;
  player2: PlayerCalculatedStats;
  player3: PlayerCalculatedStats;
  player4: PlayerCalculatedStats;
};

export const AllPlayersProgressIndicator: React.FC<props> = observer(
  ({ title, player1, player2, player3, player4, showPercentage }) => {
    const matchDetailsStore = useMatchDetailsStore();
    return (
      <div style={styles.container}>
        <TCText
          value={title}
          style={{
            fontSize: 12,
            fontWeight: "400",
            color: Colors.lightGoldenWithOpacity,
            textAlign: "center",
            marginBottom: 5,
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
          }}
        >
          <PlayerProgress
            color={
              matchDetailsStore.colorMap.get(player1.id ?? 0) ??
              Colors.darkBrown
            }
            flex={showPercentage ? player1.percentage : player1.value}
            percentage={
              showPercentage
                ? `${player1.percentage}%`
                : player1.value.toString()
            }
            progressStyle={{
              borderTopLeftRadius: 100,
              borderBottomLeftRadius: 100,
            }}
          />
          <PlayerProgress
            color={
              matchDetailsStore.colorMap.get(player2.id ?? 0) ?? Colors.yellow
            }
            flex={showPercentage ? player2.percentage : player2.value}
            percentage={
              showPercentage
                ? `${player2.percentage}%`
                : player2.value.toString()
            }
          />
          <PlayerProgress
            color={
              matchDetailsStore.colorMap.get(player3.id ?? 0) ?? Colors.grey
            }
            flex={showPercentage ? player3.percentage : player3.value}
            percentage={
              showPercentage
                ? `${player3.percentage}%`
                : player3.value.toString()
            }
          />
          <PlayerProgress
            color={
              matchDetailsStore.colorMap.get(player4.id ?? 0) ?? Colors.gold
            }
            flex={showPercentage ? player4.percentage : player4.value}
            percentage={
              showPercentage
                ? `${player4.percentage}%`
                : player4.value.toString()
            }
            percentageStyle={{ textAlign: "right" }}
            progressStyle={{
              borderTopRightRadius: 100,
              borderBottomRightRadius: 100,
            }}
          />
        </div>
      </div>
    );
  }
);

const styles = {
  container: {
    flex: 1,
  },
};

type playerProgressProps = {
  percentage: string;
  percentageStyle?: React.CSSProperties;
  color: string;
  flex: number;
  progressStyle?: React.CSSProperties;
};

export const PlayerProgress: React.FC<playerProgressProps> = ({
  percentage,
  percentageStyle,
  color,
  progressStyle,
  flex,
}) => {
  return (
    <div style={{ flex: flex }}>
      <div style={{ height: 6, backgroundColor: color, ...progressStyle }} />
      <TCText
        numberOfLines={1}
        value={percentage}
        style={{
          fontWeight: "600",
          fontSize: 10,
          color: Colors.white,
          textAlign: "left",
          marginTop: 3,
          ...percentageStyle,
        }}
      />
    </div>
  );
};
